module.exports = ".error-message {\r\n\ttext-align: center; \r\n\tfont-size: 12px\r\n}\r\n\r\nmd-expansion-panel {\r\n\twidth: 99.9%;\r\n\tmax-width: 100%;\r\n}\r\n\r\nth button {\r\n\tcolor: black;\r\n\tcursor: pointer;\r\n}\r\n\r\n.action-column {\r\n\twidth: 40px !important;\r\n\tmax-width: 40px !important;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/standards/standard-calibration/standard-calibration.component.css
// module id = ./src/app/standards/standard-calibration/standard-calibration.component.css
// module chunks = main